export const URL_SEARCHER =
    process.env.ENVIRONMENT === "PDN"
        ? "https://integraciones.comfama.com/tran/TRA-EMP-BusquedaContenidoEmpresarial/search/api/v1/search-article"
        : "https://integracionesqa.comfama.com/tran/TRA-EMP-BusquedaContenidoEmpresarial/search/api/v1/search-article"

export const URL_ARTICLE_RATING =
    process.env.ENVIRONMENT === "PDN"
        ? "https://integraciones.comfama.com/tran/TRA-EMP-BusquedaContenidoEmpresarial/search/api/v1/rating-article"
        : "https://integracionesqa.comfama.com/tran/TRA-EMP-BusquedaContenidoEmpresarial/search/api/v1/rating-article"